import { GUIA, GUIA_EN } from "../guiaCopy";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const GuiaPage = ({ lang }) => {
  const c = lang === "en" ? GUIA_EN : GUIA;
  return (
    <main data-testid="guia-page">
      <section className="limp-hero grain">
        <div className="limp-hero-inner">
          <p className="eyebrow lt" data-testid="guia-eyebrow">
            <span className="eyebrow-rule" />
            {c.eyebrow}
          </p>
          <h1 data-testid="guia-headline">
            {c.h1a} <em>{c.h1b}</em>
          </h1>
          <p className="lead lt-2">{c.lead}</p>
        </div>
      </section>

      <section className="limp-section">
        <div className="limp-inner">
          <h2>{c.steps.h}</h2>
          <ol className="limp-steps guia-steps">
            {c.steps.items.map((s, i) => (
              <li key={i}>
                <div>
                  <strong className="guia-step-h">{s.h}</strong>
                  <p>{s.p}</p>
                </div>
              </li>
            ))}
          </ol>
          <p className="guia-tip" data-testid="guia-tip">{c.tip}</p>
        </div>
      </section>

      <section className="limp-section limp-tinted">
        <div className="limp-inner">
          <h2>{c.errors.h}</h2>
          <ul className="limp-knows-list">
            {c.errors.items.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="limp-form-section grain" id="guia-cta" data-testid="guia-cta-section">
        <h2>{c.cta.h}</h2>
        <p className="guia-cta-p">{c.cta.p}</p>
        <div className="actions guia-actions">
          <a className="btn-gold" href="/#contact" data-testid="guia-cta-btn">
            {c.cta.btn} <span className="arr">↗</span>
          </a>
          <a className="textlink lt" href="/limpieza" data-testid="guia-cta-limpieza">
            {c.cta.btnLimpieza} <span className="arr">→</span>
          </a>
        </div>
      </section>
    </main>
  );
};

export default GuiaPage;
